import React, { Component } from 'react'
import PropTypes from 'prop-types'

import './style.scss'

export default class DropDownMenuItem extends Component {
    static propTypes = {
        callback: PropTypes.func,
        icon: PropTypes.string.isRequired,
        text: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    }

    render() {
        const { callback, icon, text } = this.props

        return (
            <div className={'drop-down-item'} onClick={callback}>
                <div className={`drop-down-item__icon type-${icon}`} />
                <div className={'drop-down-item__text'}>{text}</div>
            </div>
        )
    }
}
